import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24c1.5 0 11.55-5.1 12-18.45-6.479 0-9.503-3.04-11.725-5.274L12 0c-.175.187-.35.378-.528.572C9.368 2.872 6.916 5.55 0 5.55.45 18.9 10.5 24 12 24zm.38-16.972L12 6.585l-.38.443-4.5 5.25-.279.325.28.326 4.5 5.25.379.443.38-.443 4.5-5.25.279-.325-.28-.326-4.5-5.25zM12 17.085l-3.841-4.482L12 8.123l3.841 4.482L12 17.084z"
});

var SvgShieldFilled = function SvgShieldFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgShieldFilled;